import type { TplMaturityBand, TplMaturityPillars } from '../services/tplMaturityModel';

export type { TplMaturityBand, TplMaturityPillars };

export interface TplMaturityPresentation {
  score: number;
  band: TplMaturityBand;
  pillars: TplMaturityPillars;
  bandLabel: string;
}

/** Adapta o modelo completo para componentes que consomem apresentação resumida. */
export function toTplMaturityPresentation(model: {
  score: number;
  band: TplMaturityBand;
  bandLabel: string;
  pillars: TplMaturityPillars;
}): TplMaturityPresentation {
  return {
    score: model.score,
    band: model.band,
    bandLabel: model.bandLabel,
    pillars: model.pillars,
  };
}
